import type { ReactNode } from "react";
import "./public.css";

type PublicShellProps = {
  children?: ReactNode;
};

/**
 * Scopes the Público A palette (public.css) to `.public-pages`.
 * Later tasks mount the header, footer, and pages inside it.
 * The shell does not paint chrome of its own.
 */
export default function PublicShell({ children }: PublicShellProps) {
  return <div className="public-pages">{children}</div>;
}
